import "./instrument";
import "./analytics";

import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import App from "./App";
import { IncomingCallProvider } from "components/IncomingCall/IncomingCallContext";
import { UserStatusProvider } from "components/UserStatus/UserStatusContext";
import { SocketProvider } from "providers/SocketProvider";
import { RolePermissionsListener } from "hooks/useRolePermissionsListener";
import { ErrorFallback } from "components/ErrorFallback";

import "semantic-ui-less/semantic.less";
import "./index.css";
import "./styles/dark-mode.css";
import "./styles/tailwind.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      <SocketProvider>
        <RolePermissionsListener />
        <UserStatusProvider>
          <IncomingCallProvider>
            <App />
          </IncomingCallProvider>
        </UserStatusProvider>
      </SocketProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
